import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/** Only renders children when user is authenticated AND admin. */
export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAF2E8]" data-testid="auth-loading">
        <div className="w-8 h-8 border-4 border-[#F39200] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace state={{ from: location }} />;
  if (!user.is_admin) return <Navigate to="/admin/login" replace state={{ error: 'This account is not authorised to access the admin panel.' }} />;
  return children;
}
